import Service from "../../services";

const FormRL = {
    namespaced: true,
    state: {
        formResearch: 1,
        researchID: '',
    },
    mutations: {
        SET_PAGE:(state,page)=>{
            state.formResearch = page;
        },
        SET_RESEARCH_ID:(state,res)=>{
            state.researchID = res.researchID;
        },
    },
    actions: {
        saveRL01({commit},data) {
            return Service.FormRL.saveRL01(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRL02_1({commit},data) {
            return Service.FormRL.saveRL02_1(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRL02_2({commit},data) {
            return Service.FormRL.saveRL02_2(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRL02_3({commit},data) {
            return Service.FormRL.saveRL02_3(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRL03({commit},data) {
            return Service.FormRL.saveRL03(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRL04({commit},data) {
            return Service.FormRL.saveRL04(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRL05({commit},data) {
            return Service.FormRL.saveRL05(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRL06({commit},data) {
            return Service.FormRL.saveRL06(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRL07({commit},data) {
            return Service.FormRL.saveRL07(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRL08({commit},data) {
            return Service.FormRL.saveRL08(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRL09({commit},data) {
            return Service.FormRL.saveRL09(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRL10({commit},data) {
            return Service.FormRL.saveRL10(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveRO02({commit},data) {
            return Service.FormRL.saveRO02(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRL01({commit},data) {
            return Service.FormRL.getRL01(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRL02_1({commit},data) {
            return Service.FormRL.getRL02_1(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRL02_2({commit},data) {
            return Service.FormRL.getRL02_2(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRL02_3({commit},data) {
            return Service.FormRL.getRL02_3(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRL03({commit},data) {
            return Service.FormRL.getRL03(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRL04({commit},data) {
            return Service.FormRL.getRL04(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRL05({commit},data) {
            return Service.FormRL.getRL05(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRL06({commit},data) {
            return Service.FormRL.getRL06(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRL07({commit},data) {
            return Service.FormRL.getRL07(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRL08({commit},data) {
            return Service.FormRL.getRL08(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRL09({commit},data) {
            return Service.FormRL.getRL09(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRL10({commit},data) {
            return Service.FormRL.getRL10(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRO02({commit},data) {
            return Service.FormRL.getRO02(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
    }
}

export default FormRL;
